/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes
import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as VerifyImport } from './routes/verify'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
})

const VerifyRoute = VerifyImport.update({
    path: '/verify',
    getParentRoute: () => rootRoute,
})

const IndexRoute = IndexImport.update({
    path: '/',
    getParentRoute: () => rootRoute,
})

// Populate the FileRoutesByPath interface
// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  VerifyRoute,
  LoginRoute,
])

